import moment from "moment";
import { RelatedDocument } from "../../models";
import { CustomInputMapping, CustomInputMappingField } from "../../redux";
import { getCalculatedWithUnits, getUnitsOfcalculateField, isValidCalculated, JsonDataType } from "../customInputMapping";

export const getMappingAutomaticFields = (mapping: CustomInputMapping) => {
    if(!mapping.isAutomaticTitle) return []
    return mapping.customDataMapping.customFieldsMappings.filter(x => x.automaticTitleOrder || x.automaticTitleOrder === 0)
}

const isExistsBusinessIdField = (mapping: CustomInputMapping): boolean => {
    const item = mapping.customDataMapping.customFieldsMappings.find(x => x.type === 'businessId')
    return !!item
}

export const isBusinessIdShouldBeInAutomaticTitle = (mapping: CustomInputMapping): boolean => {
    if(!mapping.isAutomaticTitle) return false
    if(!isExistsBusinessIdField(mapping)) return false

    const businessIdField = mapping.customDataMapping.customFieldsMappings.find(x => x.type === 'businessId')
    if(!businessIdField) return false

    const automaticFields = getMappingAutomaticFields(mapping)
    if(!automaticFields.length) return false

    return !!automaticFields.find(x => x.sourceField === businessIdField.sourceField)
}

export const isFieldShouldBeInAutomaticTitle = (mapping: CustomInputMapping, sourceField: string) => {
    if(!mapping.isAutomaticTitle) return false
    
    const field = mapping.customDataMapping.customFieldsMappings.find(x => x.sourceField === sourceField)
    if(!field) return false
    
    const automaticFields = getMappingAutomaticFields(mapping)
    if(!automaticFields.length) return false
    return !!automaticFields.find(x => x.sourceField === field.sourceField)
}

export const isFieldsShouldBeInAutomaticTitle = (mapping: CustomInputMapping, sourceFields: string[]) => {
    if(!mapping.isAutomaticTitle) return false
    
    return sourceFields.some(f => isFieldShouldBeInAutomaticTitle(mapping, f))
}

export const isShouldUpdateAutomaticTitleOnChangeRelated = (mapping: CustomInputMapping, related: RelatedDocument[], prevRel: RelatedDocument[]) => {
    if(!mapping.isAutomaticTitle) return false
    if(related.length === prevRel.length) return false
    const automaticFields = getMappingAutomaticFields(mapping)
    if(!automaticFields.length) return false

    if(related.length < prevRel.length) {
        const ids = related.map(x => x.relatedDocumentId)
        const rel = prevRel.reduce((accum: RelatedDocument[], cur: RelatedDocument) => {
            if(!ids.includes(cur.relatedDocumentId)) return [...accum, cur]
            return accum
        }, [])

        const datatypes = Array.from(new Set(rel.map(x => x.dataType)))

        return !!automaticFields.find(x => x.type === 'datatype' && !!x.dataType && datatypes.includes(x.dataType))
    }
    const datatypes = Array.from(new Set(related.map(x => x.dataType)))

    return !!automaticFields.find(x => x.type === 'datatype' && !!x.dataType && datatypes.includes(x.dataType))
}

export const generateTitle = (data: JsonDataType, mapping: CustomInputMapping, related?: RelatedDocument[], businessId?: string | null) => {        
    let title = ''

    const sort = (a: CustomInputMappingField, b: CustomInputMappingField) => {
        return (a.automaticTitleOrder ? a.automaticTitleOrder : 0) - (b.automaticTitleOrder ? b.automaticTitleOrder : 0)
    }    

    mapping.customDataMapping.customFieldsMappings
        .filter(x => x.automaticTitleOrder || x.automaticTitleOrder === 0)
        .sort(sort)
        .map((x) => {
            let titleValue = ''
            if (x.type === 'datatype') {

                // let related;
                // if(inputState.data && inputState.data.documentCreationInfo.RelatedDocuments){
                //     related = inputState.data ? inputState.data.documentCreationInfo.RelatedDocuments : null
                // }else{
                // }


                 
                if (related) {
                    related.filter(doc => doc.dataType === x.dataType).map((doc) => {
                        titleValue = titleValue && titleValue !== doc.title ? titleValue + ', ' + doc.title : doc.title
                    })
                } else if (data[x.sourceField]) {
                    titleValue = titleValue ? titleValue + ', ' + data[x.sourceField] : '' + data[x.sourceField]
                }



            } else if (x.type === 'date') {
                if (data[x.sourceField]) {
                    titleValue = '' + moment(data[x.sourceField]).format("DD/MM/YYYY")
                }
            }
            else if (x.type === 'dateTime') {
                if (data[x.sourceField]) {
                    titleValue = '' + moment(data[x.sourceField]).format("DD/MM - HH:mm")
                }
            }
            else if (x.type === 'title') {
                    titleValue = '' + x.fieldName
            }
            else if (x.type === 'businessId' && !!businessId) {
                titleValue = '' + businessId
            }
            else if (x.type === 'calculation' && isValidCalculated((data[x.sourceField] ?? '') as string)) {
                const units = getUnitsOfcalculateField(x)
                const val = getCalculatedWithUnits((data[x.sourceField] ?? '') as string, units)
                titleValue = '' + val
            }
            else {
                if (data[x.sourceField]) {
                    titleValue = '' + data[x.sourceField]
                }
            }

            if (titleValue) {
                title = title ? title + (!!mapping.isWithoutSeparateTitleByCommas ? ' ' : ', ') + titleValue : titleValue
            }

        })
    
    return title
}